import { FCX, Tabs } from "@datassential/platform-ui-lib";
import { ComponentProps } from "react";

type HomeSectionTabsProps = Omit<ComponentProps<typeof Tabs>, 'className' | 'modifiers'>;

const HomeSectionTabs: FCX<HomeSectionTabsProps> = (props) => {
    return (
        <Tabs className="HomeSectionTabs" {...props} />
    );
};

export default HomeSectionTabs;